import { Component, OnInit, ViewChild, Renderer2, OnDestroy } from '@angular/core';
import moment from 'moment';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

//Services
import { UtilityService } from '../../../core/services/utility.service';
import { TimeoutService } from 'src/app/core/services/timeout.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { SignalRService } from './../../../core/services/signal-r.service';
import { ChecklistService } from './../services/checklist.service';

//modals
import { WarningModalComponent } from '../../../modals/shared/warning-modal/warning-modal.component';
import { AddAttachmentModalComponent } from 'src/app/modals/shared/add-attachment-modal/add-attachment-modal.component';
import { ViewChecklistWorkflowModalComponent } from '../../../modals/checklist/view-checklist-workflow-modal/view-checklist-workflow-modal.component';
import { SubmitChecklistSignModalComponent } from '../../../modals/shared/submit-checklist-sign-modal/submit-checklist-sign-modal.component';
import { ChecklistItemClickSignModalComponent } from '../../../modals/shared/checklist-item-click-sign-modal/checklist-item-click-sign-modal.component';
import { HRIMPdfViewerComponent } from '../../../shared/component/pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'app-checklist-form',
  templateUrl: './checklist-form.component.html',
  styleUrls: ['./checklist-form.component.css'],
})
export class ChecklistFormComponent implements OnInit, OnDestroy {
  @ViewChild('checklistForm', { static: false }) checklistForm: NgForm;
  @ViewChild('signaturePad', { static: false }) signaturePad;
  @ViewChild('signaturePad2', { static: false }) signaturePad2;

  @ViewChild(HRIMPdfViewerComponent) private pdfViewer: HRIMPdfViewerComponent;

  portalSettings: any;
  employeeInfo: any;
  format: string;
  formData: { [key: string]: any } = {};
  datePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
  };
  mobileMode = false;
  currencySymbol: string;
  alert: any;
  signatureNEmpty: boolean[] = [];
  signatureNEmpty2: boolean[] = [];
  options: { [key: string]: any } = {};
  latitude: any;
  longitude: any;
  fields: Object = { text: 'ChoiceLongName', id: 'ChoiceShortName' };
  enableCheckboxSign = false;
  checklistLoaded = false;
  checklistInstanceID: any = null;
  updateOperations = 0;
  attemptedOperations = 0;
  successfulOpeartions = 0;
  errorCount = 0;
  updateQueue: any[] = [];
  typeSign = false;
  templateInfo: any = null;
  signInitDirty = false;
  isCheckAdmin = false;
  finalizeOn = false;
  isSubmitted = true;
  signInitDirtyLoad = false;
  submitting = false;
  downloadQueryString: any;
  checklistItems: any[] = [];
  checklistDetails: any;
  groupedFields: any;
  checklistTextHeader: any;
  missingAttachmentMsg: any;
  reqID: any = null;
  panelWidthInit = 130;
  panelHeightInit = 80;
  panelWidthSign = 270;
  panelHeightSign = 180;
  item: any;
  lastSave: { [key: string]: any } = {};
  saveText: string;
  isATS = false;
  isOnboarding = false;
  onboardID: any = null;
  stageID: any;
  routing: any;
  altMatch: any;
  actionItemMatch: any;
  onboardOverride = false;
  missFieldAlert = false;
  dropdownValues: any[] = [];
  headerFields: any[] = [];
  headerValues: any[] = [];
  originalValues: any[] = [];
  currentHeaderValue: any[] = [];
  redBorder = false;
  mode: string;
  disableEmployeeSelection = false;
  pdfFileIsDirty: boolean;
  signaturePadOptions: Object = {
    canvasWidth: 90,
    canvasHeight: 50,
  };
  signaturePad2Options: Object = {
    canvasWidth: 240,
    canvasHeight: 150,
  };
  signaturePadMainOptions: Object = {
    canvasWidth: 430,
    canvasHeight: 150,
  };

  constructor(
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private hiringService: HiringService,
    private employeeService: EmployeeService,
    private signalRService: SignalRService,
    private checklistService: ChecklistService,
    private utilityService: UtilityService,
    private modalService: NgbModal,
    private timeoutService: TimeoutService,
    private sharedModalService: BsModalService,
    private renderer: Renderer2,
    private router: Router
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.signalRService.establishHub('progressHub', 'downloadComplete');
    this.format = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.pdfFileIsDirty = false;
    this.formData = {};
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == '1' ? true : false;

    //SignalR connection
    this.signalRService.downloadCompletedEvent.subscribe(() => {
      setTimeout(() => {
        this.utilityService.closeModal();
      }, 1000);
    });

    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo?.PRCo);

    this.mobileMode = this.utilityService.isMobileMode();
    this.datePickerOptions = {
      dateInputFormat: this.format,
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
    };
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: NgxCurrencyInputMode.Natural };

    this.utilityService.openModal();
    this.getInfoByOnboardID();
    this.getRouteData();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }
  }

  ngOnDestroy(): void {
    // Stop SignalR connection to prevent multiple connections
    this.signalRService.stopConnection();
  }

  handleNumericInput(event: any, item: any): void {
    const input = event.target as HTMLInputElement;
    let currentValue = input.value;

    // Remove all invalid characters except the first character minus sign
    currentValue = currentValue.replace(/[^0-9.-]/g, '');

    // Check for minus sign at the beginning
    if (currentValue.startsWith('-')) {
      currentValue = '-' + currentValue.slice(1).replace(/-/g, '');
    } else {
      currentValue = currentValue.replace(/-/g, '');
    }

    // Allow only one decimal point
    const parts = currentValue.split('.');
    if (parts.length > 2) {
      currentValue = parts[0] + '.' + parts.slice(1).join('');
    }

    if (currentValue !== input.value) {
      input.value = currentValue;
      item.ItemResponse = currentValue;
    }
  }

  getRouteData(): void {
    const applicantRegex =
      /#(?:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})[/]([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})[/](-?\d+))[/](AS|RD)$/i;
    const applicantMatch = applicantRegex.exec(window.location.hash);
    if (applicantMatch != null) {
      this.reqID = applicantMatch[1];
      this.onboardID = applicantMatch[2];
      this.stageID = applicantMatch[3];
      this.routing = applicantMatch[4];
      this.isATS = true;
    }
    const onboardRegex = /#(?:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}))?$/i;
    const onboardMatch = onboardRegex.exec(window.location.hash);
    if (onboardMatch != null) {
      this.onboardID = onboardMatch[1];
      this.isOnboarding = true;
    }
    const path = window.location.pathname;
    const hash = window.location.hash;
    const routeRegex = /^[/]Checklist[/]ChecklistForm[/](\d+)?[/]?$/i;
    const altRegex = /^[/]Careers[/]OnboardingForm[/](\d+)?[/]?$/i;
    const modeRegex = /^#[/]mode[/](\w)$/;
    const routeMatch = routeRegex.exec(path);
    this.altMatch = altRegex.exec(path);
    const modeMatch = modeRegex.exec(hash);
    if (routeMatch != null) {
      this.mode = modeMatch != null ? modeMatch[1] : 'C';
      this.checklistInstanceID = parseInt(routeMatch[1]);
    } else if (this.altMatch != null) {
      this.mode = 'O';
      this.checklistInstanceID = parseInt(this.altMatch[1]);
    }

    this.getChecklistItems();
    this.getChecklistDetails();
    this.getHeaderFields();
  }

  getInfoByOnboardID(): void {
    if (this.altMatch != null) {
      this.checklistService.getInfoByOnboardID().then((response: any) => {
        if (response.DateSubmitted != null) {
          this.isSubmitted = true;
          this.onboardOverride = true;
        } else {
          this.isSubmitted = false;
          this.onboardOverride = false;
        }
      });
    }
  }

  getChecklistItems(): void {
    this.signInitDirty = false;
    this.checklistService.getTemplateInfoFromInstance(this.checklistInstanceID).then((response: any) => {
      this.templateInfo = response;

      if (this.templateInfo == null) {
        this.utilityService.closeModal();
        this.alert = { type: 'danger', msg: 'Unable to get Checklist Template Info.' };
        return;
      }

      this.hiringService.getItem(this.checklistInstanceID).then((response: any) => {
        this.checklistItems = response;
        if (this.checklistItems != null && this.checklistItems.length < 1) {
          if (!this.templateInfo.FillablePDFAttachmentID) {
            this.alert = { type: 'danger', msg: 'There are no items on this form.' };
          } else {
            this.checklistService.getChecklistInstancePDF(this.checklistInstanceID).then((response: any) => {
              this.pdfViewer.setPDFData(response, this.generateFilename());
              this.checklistLoaded = true;
            });
          }
          this.utilityService.closeModal();
        } else {
          this.signatureNEmpty = [];
          this.signatureNEmpty2 = [];
          if (this.checklistItems != null) {
            this.checklistItems.forEach(val => {
              val.typeSign = false;
              val.hideSign = false;
              if (val.ItemLongPrompt != null) {
                val.ItemLongPromptDisplay = val.ItemLongPrompt;
              }
              if (val.ResponseTypeID == 4) {
                if (val.ItemResponse != null) {
                  const temp = val.ItemResponse.split(':');
                  let hour = parseInt(temp[0]);
                  const min = parseInt(temp[1].substring(0, 2));
                  if (hour == 12 && temp[1].substring(2, 4) == 'AM') hour = 0;
                  else if (temp[1].substring(2, 4) == 'PM' && hour != 12) hour += 12;
                  val.ItemResponse = new Date(2000, 1, 1, hour, min, 1);
                }
              }
              if (val.ChecklistLookupID != null) {
                val.dataList = [];
                this.hiringService
                  .getChoicesByTemplateItemID(val.ChecklistTemplateItemID, val.ChecklistInstanceID)
                  .then((choiceRespone: any) => {
                    if (choiceRespone != null && choiceRespone.length > 0) {
                      val.dataList = choiceRespone;
                    }
                    if (val.ResponseTypeID == 9) {
                      val.checkboxList = [];
                      if (val.ItemResponse != null) {
                        val.ItemResponse.split(',').forEach((val2: any) => {
                          if (val2.length > 0) {
                            //To select items in syncfusion - checklist view, need to set isChecked and update the display list
                            val.dataList.forEach((element: any) => {
                              if (element.ChoiceShortName == val2) {
                                element.isChecked = true;
                                val.checkboxList.push(element);
                              }
                            });
                          }
                        });
                      }
                    }
                  });
              }
              if (val.ResponseTypeID == 5) {
                if (val.ItemResponseBinary == null) {
                  val.img = null;
                } else {
                  val.img = 'data:image/png;base64,' + val.ItemResponseBinary;
                }
              }
              if (val.ResponseTypeID == 11) {
                if (val.ItemResponseBinary == null) {
                  val.img = null;
                } else {
                  val.img = 'data:image/png;base64,' + val.ItemResponseBinary;
                }
              }
              if (val.ResponseTypeID == 13) {
                if (val.ItemResponse != null && val.ItemResponse.length >= 10 && val.ItemResponse.indexOf('/') > -1) {
                  val.ItemResponse = this.utilityService.convertStringToDate(val.ItemResponse.substr(0, 10));
                }
              }
              if (val.ResponseTypeID == 6 && val.ItemResponse == null) {
                val.ItemResponse = 'N';
              }
              if (val.ResponseTypeID == 16 && val.ItemResponse != null) {
                val.ItemResponse = parseFloat(val.ItemResponse);
              }
              if (val.ResponseTypeID == 25 && val.ItemResponse != null) {
                val.ItemResponse = val.ItemResponse * 100 + '%';
              }
              if (val.TemplateHasAttachments == 1) {
                const requestParam = 'moduleID=' + 38 + '&recordID=' + val.ChecklistTemplateItemID;
                this.employeeService.getFileAttachmentList(requestParam).then((fileResponse: any[]) => {
                  if (fileResponse != null) {
                    val.longPic = [];
                    val.caption = [];
                    val.fileIsImage = [];
                    val.fileURL = [];
                    val.filename = [];
                    fileResponse.forEach((val2, key2) => {
                      //file is an image
                      if (val2.AttachmentFileName.match(/\.(jpg|jpeg|png|gif)$/i)) {
                        val.fileIsImage[key2] = true;
                        this.employeeService.getFileAttachmentBinary(val2.FileAttachmentID).then((response: any) => {
                          val.caption[key2] = val2.AttachmentCaption;
                          val.longPic[key2] = 'data:image/png;base64,' + response;
                          val.fileURL[key2] = '/Employee/GetFileAttachmentData?fileAttachmentID=' + val2.FileAttachmentID;
                          val.filename[key2] = val2.AttachmentFileName;
                        });
                      } else {
                        val.caption[key2] = val2.AttachmentCaption;
                        val.longPic[key2] = null;
                        val.fileURL[key2] = '/Employee/GetFileAttachmentData?fileAttachmentID=' + val2.FileAttachmentID;
                        val.fileIsImage[key2] = false;
                        val.filename[key2] = val2.AttachmentFileName;
                      }
                    });
                  }
                });
              }
            });

            this.errorCount = 0;
            this.checklistItems.forEach(val => {
              if (!val.IsAdminField) {
                if (val.ResponseTypeID == 5 || val.ResponseTypeID == 11) {
                  if (val.img == null && val.IsRequired) {
                    this.errorCount++;
                  }
                } else if (val.ResponseTypeID == 16) {
                  if ((val.ItemResponse == null || val.ItemResponse.length < 1 || isNaN(val.ItemResponse)) && val.IsRequired) {
                    this.errorCount++;
                  }
                } else if (val.ResponseTypeID == 3 || val.ResponseTypeID == 12 || val.ResponseTypeID == 26) {
                  if ((val.ItemComments == null || val.ItemComments.length < 1) && val.IsRequired) {
                    this.errorCount++;
                  }
                } else {
                  if ((val.ItemResponse == null || val.ItemResponse.length < 1) && val.IsRequired) {
                    this.errorCount++;
                  }
                }
                if (val.IsRequiredAttachment && !val.ItemHasAttachments) this.errorCount++;
              }
            });
            if (this.errorCount != 0) this.checklistForm?.form.markAsDirty();
            else this.checklistForm?.form.markAsPristine();

            this.groupChecklistItems();
            this.checklistLoaded = true;
          }
        }
      });
    });
  }

  clearInit(signPad: any, id: number, mode: string): void {
    if (signPad != null) {
      signPad.clear();
    }
    mode == 'init' ? (this.signatureNEmpty[id] = false) : (this.signatureNEmpty2[id] = false);
  }

  updateCheckboxList(args: any, item: any): void {
    if (args.isChecked) {
      item.checkboxList.push(args.data);
    } else {
      const index = item.checkboxList.findIndex(i => i.ChoiceShortName === args.data.ChoiceShortName);
      if (index > -1) {
        item.checkboxList.splice(index, 1);
      }
    }
    this.updateItem(item);
  }

  getChecklistDetails(): void {
    this.checklistService.getChecklistInstanceDetails(this.checklistInstanceID).then((response: any) => {
      this.checklistDetails = response;
      this.checklistTextHeader =
        response.ChecklistTextHeader != null ? response.ChecklistTextHeader.replace('target=""', 'target="_blank"') : '';
      if (this.checklistDetails === null || this.checklistDetails === '') {
        if (window.location.pathname.indexOf('Onboarding') > -1) {
          this.router.navigate(['/careers/tasks']);
        } else {
          this.navigateToMainPageURL();
        }
      }
      this.isCheckAdmin = this.mode == 'H' ? response.IsHRActionItemsAdmin : response.IsCheckListAdmin;
      if (this.checklistDetails.SubmittedOn == null) {
        this.finalizeOn = true;
      } else this.finalizeOn = false;
      if (!this.onboardOverride) {
        if (this.checklistDetails.SignedOn == null) this.isSubmitted = false;
        else this.isSubmitted = true;
      }
      if (!this.finalizeOn) this.isSubmitted = true;
      if (this.checklistDetails.SignedOn != null) {
        this.checklistDetails.SignDisplay = moment(parseInt(this.checklistDetails.SignedOn.substr(6)))
          .utc()
          .format(this.format);
        this.checklistDetails.img = 'data:image/png;base64,' + response.SignatureData;
      }
      this.downloadQueryString =
        '?checklistInstanceIDs=' +
        this.checklistInstanceID +
        '&filenames=' +
        this.checklistDetails.ChecklistTemplateName +
        '.pdf' +
        '&templateID=' +
        this.checklistDetails.ChecklistTemplateID;
    });
  }

  getHeaderFields(): void {
    this.dropdownValues = [];
    this.checklistService.getHeaderFields(this.checklistInstanceID).then((response: any) => {
      this.headerFields = response;
      this.groupedFields = [];
      let group = [];
      this.headerValues = [];
      this.originalValues = [];
      //group header fields and store their values
      for (let i = 0; i < this.headerFields.length; i++) {
        //store header field value
        let headerValue = this.headerFields[i].FieldValue;
        if (this.headerFields[i].FieldType == 'date') {
          if (headerValue != null) {
            headerValue = this.utilityService.convertStringToDate(headerValue.substring(0, 10));
          }
          this.headerValues[this.headerFields[i].HeaderFieldName] = headerValue;
          this.originalValues[this.headerFields[i].HeaderFieldName] = headerValue;
        } else if (this.headerFields[i].FieldType == 'dropdown') {
          this.getHeaderFieldChoices(this.headerFields[i]);
          this.headerValues[this.headerFields[i].HeaderFieldName] = headerValue;
          this.originalValues[this.headerFields[i].HeaderFieldName] = headerValue;
        } else if (this.headerFields[i].FieldType == 'numeric') {
          this.headerValues[this.headerFields[i].HeaderFieldName] = headerValue != null ? parseInt(headerValue) : headerValue;
          this.originalValues[this.headerFields[i].HeaderFieldName] = headerValue != null ? parseInt(headerValue) : headerValue;
        } else if (this.headerFields[i].FieldType == 'checkbox') {
          if (headerValue == 'True') headerValue = true;
          else headerValue = false;
          this.headerValues[this.headerFields[i].HeaderFieldName] = headerValue;
          this.originalValues[this.headerFields[i].HeaderFieldName] = headerValue;
        } else if (this.headerFields[i].FieldType == 'time') {
          if (headerValue != null) {
            const temp = headerValue.split(':');
            const time = new Date();
            if (temp[1].substr(temp[1].length - 2, temp[1].length) == 'AM') {
              let hour = parseInt(temp[0]);
              if (hour == 12) hour = 0;
              time.setHours(hour, parseInt(temp[1].substr(0, 2)));
            } else {
              let hour = parseInt(temp[0]) + 12;
              if (hour == 24) hour = 12;
              time.setHours(hour, parseInt(temp[1].substr(0, 2)));
            }
            this.headerValues[this.headerFields[i].HeaderFieldName] = time;
            this.originalValues[this.headerFields[i].HeaderFieldName] = time;
          }
        } else {
          this.headerValues[this.headerFields[i].HeaderFieldName] = headerValue;
          this.originalValues[this.headerFields[i].HeaderFieldName] = headerValue;
        }

        //group header field
        if (i % 3 == 0) {
          if (group.length != 0) this.groupedFields.push(group);
          group = [];
          group.push(this.headerFields[i]);
        } else {
          group.push(this.headerFields[i]);
        }
      }
      if (group.length != 0) {
        this.groupedFields.push(group);
      }
    });
  }

  getHeaderFieldChoices(headerField: any): void {
    this.checklistService
      .getChoicesByHeaderFieldID(
        headerField.ChecklistHeaderFieldID,
        this.checklistInstanceID,
        this.employeeInfo ? this.employeeInfo.PRCo : null
      )
      .then((response: any) => {
        let dropdownValues = response;

        dropdownValues.forEach(val => {
          val.ChoiceDisplayName = val.ChoiceLongName;
        });

        //For timecard non-admin employee, select the Action item created employee by default in Employee Name dropdown.
        if (this.mode == 'H' && headerField.HeaderFieldName == 'Employee Name' && dropdownValues.length == 0) {
          dropdownValues = [
            {
              ChoiceDisplayName: this.employeeInfo.Employee + ' - ' + this.employeeInfo.FirstName + ' ' + this.employeeInfo.LastName,
              ChoiceShortName: this.employeeInfo.PREHKeyID,
            },
          ];
          this.disableEmployeeSelection = true;
          this.headerValues[headerField.HeaderFieldName] = this.employeeInfo.PREHKeyID;
          this.updateHeaderFieldValue(headerField);
        } else if (!headerField.FieldIsRequired) {
          dropdownValues.unshift({ ChoiceDisplayName: 'No Selection', ChoiceShortName: null });
        }

        this.dropdownValues[headerField.ChecklistHeaderFieldID] = dropdownValues;
      });
  }

  updateHeaderFieldValue(headerField: any): void {
    if (this.originalValues[headerField.HeaderFieldName] != this.headerValues[headerField.HeaderFieldName]) {
      let tempValue = this.headerValues[headerField.HeaderFieldName];
      if (tempValue != null) {
        if (headerField.FieldType == 'date') {
          tempValue = moment(tempValue).format(this.format.toUpperCase());
        } else if (headerField.FieldType == 'time') {
          tempValue = moment(tempValue).format('hh:mm a');
        }
      }

      this.checklistService
        .updateHeaderFieldValue(this.checklistInstanceID, headerField.ChecklistHeaderFieldID, tempValue, headerField.FieldType)
        .then((response: any) => {
          this.fadeLabel(response.success);
          this.checklistForm.form.markAsPristine();
          if (!response.success) {
            this.headerValues[headerField.HeaderFieldName] =
              this.currentHeaderValue != null ? this.currentHeaderValue : this.originalValues[headerField.HeaderFieldName];
          } else {
            this.currentHeaderValue = this.headerValues[headerField.HeaderFieldName];
          }
        });
    }
  }

  //Groups checklist items and initializes checklistValues list for storing values
  groupChecklistItems(): void {
    this.formData.groupedItems = [];
    this.checklistItems.forEach((val: any) => {
      if (this.formData.groupedItems[val.ItemGrpSeq] == null) {
        this.formData.groupedItems[val.ItemGrpSeq] = [];
        this.formData.groupedItems[val.ItemGrpSeq].GroupName = val.ItemGrpName;
      }
      if ((val.IsAdminField && this.employeeInfo != null) || !val.IsAdminField) {
        this.formData.groupedItems[val.ItemGrpSeq].push(val);
        if (val.IsRequired) this.formData.groupedItems[val.ItemGrpSeq].ShowRequired = true;
      }
    });
    this.utilityService.closeModal();
  }

  updateScore(item, num): void {
    item.ItemResponse = num;
    this.updateItem(item);
  }

  saveInit(signPad: any, item: any, mode: any): void {
    if (signPad.isEmpty() == false || item.typeSign) {
      mode == 'init'
        ? (this.signatureNEmpty[item.ChecklistInstanceItemID] = false)
        : (this.signatureNEmpty2[item.ChecklistInstanceItemID] = false);
      this.updateItem(item, true, signPad);
    } else
      mode == 'init'
        ? (this.signatureNEmpty[item.ChecklistInstanceItemID] = true)
        : (this.signatureNEmpty2[item.ChecklistInstanceItemID] = true);
  }

  itemSignSave(signPad: any, type: string, data: any): void {
    if (data.typeSign == 'undefined' || !data.typeSign) data.typeSign = true;

    if (data.typeSign) {
      const modalRef = this.modalService.open(ChecklistItemClickSignModalComponent, { size: 'md', backdrop: 'static' });
      modalRef.componentInstance.type = type;
      modalRef.result
        .then(result => {
          if (result != null) {
            data.hideSign = true;
            data.img = result;
            this.updateItem(data, true, signPad);
          } else {
            data.typeSign = false;
            data.hideSign = false;
          }
        })
        .catch(res => {});
    }
  }

  updateItem(item: any, submitSign?: any, signPad?: any): void {
    setTimeout(() => {
      item.ShowError = false;
      item.ValidationError = null;
      this.signInitDirty = false;
      this.signInitDirtyLoad = true;
      if (item.ResponseTypeID == 1 || item.ResponseTypeID == 17) {
        if (item.ItemResponse == '5' || item.ItemResponse == 'NA') {
          item.ItemIsCorrected = null;
          item.CorrectedComments = null;
        } else {
          if (item.ItemIsCorrected == null) {
            item.ItemIsCorrected = false;
            item.CorrectedComments = null;
          }
        }
      }
      if (item.ResponseTypeID == 16 && item.ItemResponse != null && item.ItemResponse != '' && !isNaN(item.ItemResponse)) {
        item.ItemResponse = parseFloat(item.ItemResponse);
      }
      if (item.ResponseTypeID == 4 && item.ItemResponse != null) {
        item.TimeItemResponse = item.ItemResponse.toTimeString().substring(0, 5);
      }
      if (item.ResponseTypeID == 9) {
        item.ItemResponse = '';
        item.checkboxList.forEach((val: any) => {
          item.ItemResponse += val.ChoiceShortName + ',';
        });
      }
      let signatureData = null;
      if ((item.ResponseTypeID == 5 || item.ResponseTypeID == 11) && submitSign) {
        if (signPad == null)
          signatureData =
            item.ItemResponseBinary != null ? item.ItemResponseBinary : item.img.replace(/^data:image\/(png|jpg);base64,/, '');
        else signatureData = signPad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, '');
        if (!item.typeSign) item.img = 'data:image/png;base64,' + signatureData;
      }

      let dateString = '';
      if (item.ResponseTypeID == 13 && item.ItemResponse) {
        dateString = moment(item.ItemResponse).utc().format(this.format.toUpperCase());
      }

      let itemResponseDisplay = '';
      if (item.ResponseTypeID == 7 || (item.ResponseTypeID == 15 && item.dataList != null)) {
        item.dataList.forEach((val: any) => {
          if (val.ChoiceShortName == item.ItemResponse) itemResponseDisplay = val.ChoiceLongName;
        });
      }

      if (item.ResponseTypeID == 25) {
        let count = 0;
        if (item.ItemResponse == null) {
          item.ItemResponse = '';
        }
        for (let i = 0; i < item.ItemResponse.length; i++) {
          if (item.ItemResponse[i] == '%') count++;
        }
        if (item.ItemResponse[item.ItemResponse.length - 1] != '%' && count == 0 && item.ItemResponse.length > 0) {
          item.ItemResponse += '%';
        }
      }

      //regex validation
      let inputValid = false;
      if (item.ResponseTypeID == 3 || item.ResponseTypeID == 12 || item.ResponseTypeID == 26) {
        if (item.ValidationRegex != null && item.ValidationRegex != '' && item.ItemComments != null && item.ItemComments != '') {
          inputValid = this.checkRegex(item);
        } else {
          inputValid = true;
        }

        if (item.IsRequired && (item.ItemComments == null || item.ItemComments == '') && inputValid) inputValid = false;
      }

      this.checkErrorCount();

      if ((item.ResponseTypeID == 3 || item.ResponseTypeID == 12 || item.ResponseTypeID == 26) && !inputValid) {
        if (item.ItemComments != null && item.ItemComments != '') item.ValidationError = 'Invalid Input';
        item.ShowError = true;
        this.errorCount++;
      } else {
        const requestObj = {
          //add gps here
          checklistInstanceItemID: item.ChecklistInstanceItemID,
          itemComments: item.ItemComments,
          itemResponse:
            item.ResponseTypeID == 4
              ? item.TimeItemResponse
              : item.ResponseTypeID == 13
                ? dateString
                : item.ResponseTypeID == 25
                  ? parseInt(item.ItemResponse.slice(0, -1)) / 100
                  : item.ItemResponse,
          itemIsCorrected: item.ItemIsCorrected,
          correctedComments: item.CorrectedComments,
          signatureDataStr: signatureData,
          typeSign: item.typeSign,
          typeID: item.ResponseTypeID,
          time: null,
          latitude: this.latitude != null ? this.latitude : null,
          longitude: this.longitude != null ? this.longitude : null,
          itemResponseDisplay: itemResponseDisplay,
        };
        this.hiringService.updateItem(requestObj).then((response: any) => {
          this.fadeLabel(response.success);
          this.checklistForm?.form.markAsPristine();
          let signInitDirtyCount = 0;

          this.hiringService.getItem(this.checklistInstanceID).then((itemResponse: any) => {
            this.checklistItems.forEach((val: any) => {
              if (val.RebindDropdown) {
                if (val.ResponseTypeID == 3 || val.ResponseTypeID == 12) {
                  itemResponse.forEach((val2: any) => {
                    if (val.checklistInstanceItemID == val2.ChecklistInstanceItemID) val.ItemComments = val2.ItemComments;
                  });
                }
                if (val.ResponseTypeID == 7 || val.ResponseTypeID == 15) {
                  this.hiringService
                    .getChoicesByTemplateItemID(val.ChecklistTemplateItemID, this.checklistInstanceID)
                    .then((choiceResponse: any) => {
                      val.dataList = choiceResponse;
                    });
                }
              }
            });
          });

          this.checklistItems.forEach((val: any) => {
            if (
              (val.ResponseTypeID == 5 || val.ResponseTypeID == 11) &&
              val.ChecklistInstanceItemID == item.ChecklistInstanceItemID &&
              submitSign
            ) {
              if (signPad?.isEmpty() == false) {
                val.ItemResponseBinary = true;
                if (this.submitting) {
                  this.successfulOpeartions++;
                  if (this.successfulOpeartions == this.updateOperations) {
                    this.saveSign('submit');
                  }
                }
              } else if (submitSign && val.img != null) {
                val.ItemResponseBinary = true;
                if (this.submitting) {
                  this.successfulOpeartions++;
                  if (this.successfulOpeartions == this.updateOperations) {
                    this.saveSign('submit');
                  }
                }
              }
              if (val.img == null && val.IsRequired) {
                signInitDirtyCount++;
              }
            }
          });
          if (signInitDirtyCount > 0) this.signInitDirty = true;
          else this.signInitDirty = false;

          if (this.submitting && this.attemptedOperations == this.updateOperations && this.successfulOpeartions < this.updateOperations) {
            //something went wrong
            this.alert = { type: 'danger', msg: 'Could not submit form' };
          }
          if (this.submitting && this.attemptedOperations == this.updateOperations) this.submitting = false;

          this.signInitDirtyLoad = false;
          this.timeoutService.refreshTimeout();
        });
      }
    });
  }

  checkErrorCount(): void {
    this.errorCount = 0;
    this.formData.groupedItems.forEach((val: any) => {
      val.forEach((val2: any) => {
        if (Object.prototype.hasOwnProperty.call(val2, 'ResponseTypeID') && !val2.IsAdminField) {
          if (val2.ResponseTypeID == 5 || val2.ResponseTypeID == 11) {
            if (val2.img == null && val2.IsRequired) {
              this.errorCount++;
            }
          } else if (val2.ResponseTypeID == 16) {
            if ((val2.ItemResponse == null || val2.ItemResponse.length < 1 || isNaN(val2.ItemResponse)) && val2.IsRequired) {
              this.errorCount++;
            }
          } else if (val2.ResponseTypeID == 3 || val2.ResponseTypeID == 12 || val2.ResponseTypeID == 26) {
            if ((val2.ItemComments == null || val2.ItemComments.length < 1) && val2.IsRequired) {
              this.errorCount++;
            }
            let inputValid = false;
            if (val2.ValidationRegex != null && val2.ValidationRegex != '' && val2.ItemComments != null && val2.ItemComments != '') {
              inputValid = this.checkRegex(val2);
            } else {
              inputValid = true;
            }

            if (!inputValid) {
              this.errorCount++;
            }
          } else if (val2.ResponseTypeID == 1 || val2.ResponseTypeID == 17) {
            if ((val2.ItemResponse == '1' || val2.ItemResponse == '3') && val2.ItemIsCorrected) {
              if (val2.CorrectedComments != null) {
                if (val2.CorrectedComments.length < 1) {
                  this.errorCount++;
                }
              } else {
                this.errorCount++;
              }
            }
          } else {
            if ((val2.ItemResponse == null || val2.ItemResponse.length < 1) && val2.IsRequired) {
              this.errorCount++;
            }
          }
          if (val2.IsRequiredAttachment && !val2.ItemHasAttachments) this.errorCount++;
        }
      });
    });
    if (this.errorCount > 0) this.checklistForm?.form.markAsDirty();
    else this.checklistForm?.form.markAsPristine();
  }

  addAttachment(item): void {
    const modalRef = this.modalService.open(AddAttachmentModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.itemID = item.ChecklistInstanceItemID;
    modalRef.componentInstance.moduleID = 12;
    modalRef.componentInstance.active = true;
    modalRef.componentInstance.status = this.isSubmitted;
    modalRef.componentInstance.mobileMode = this.mobileMode;
    modalRef.result
      .then(() => {
        this.hiringService.getItem(this.checklistInstanceID).then((response: any) => {
          response.forEach((val: any) => {
            if (item.ChecklistTemplateItemID == val.ChecklistTemplateItemID) {
              item.ItemHasAttachments = val.ItemHasAttachments;
            }
          });
          this.checkErrorCount();
        });
      })
      .catch(() => {});
  }

  async submitChecklist(type): Promise<void> {
    if (!this.checklistForm.form.invalid && this.errorCount == 0) {
      this.utilityService.openModal();

      let formValid = true;
      let noAttachment = false;

      if (this.templateInfo.FillablePDFAttachmentID) {
        const pdfValErrors = this.pdfViewer.validatePdfFields();
        if (pdfValErrors != null && pdfValErrors.length > 0) {
          this.utilityService.closeModal();
          this.alert = { type: 'danger', msg: 'The following fields have validation errors:' + pdfValErrors.join(', ') };
          return;
        }
      } else {
        this.formData.groupedItems.forEach((val: any) => {
          val.forEach((val2: any) => {
            val2.itemError = false;
          });
          val.groupError = false;
        });

        this.checklistItems.forEach((item: any) => {
          if ((item.ResponseTypeID == 5 || item.ResponseTypeID == 11) && item.ItemResponseBinary == null && item.IsRequired) {
            this.signatureNEmpty2[item.ChecklistInstanceItemID] = true;
            formValid = false;
          }
        });

        this.checklistItems.forEach((val: any) => {
          if (val.IsRequiredAttachment && !val.ItemHasAttachments) {
            this.utilityService.closeModal();
            noAttachment = true;
            return;
          }
        });
      }

      if (noAttachment) {
        this.missingAttachmentMsg = 'Missing Attachment.';
        this.utilityService.closeModal();
      } else {
        if (formValid) {
          let pdfData = null;
          if (this.templateInfo.FillablePDFAttachmentID) {
            pdfData = await this.pdfViewer.getPDFData();
          }
          this.checklistService.getHeaderFields(this.checklistInstanceID).then(() => {
            this.hiringService.getItem(this.checklistInstanceID).then(() => {
              this.utilityService.closeModal();
              this.alert = null;
              const fileName = this.generateFilename();
              const modalRef = this.modalService.open(SubmitChecklistSignModalComponent, { size: 'md', backdrop: 'static' });
              modalRef.componentInstance.signed = this.checklistDetails.SignedOn;
              modalRef.componentInstance.type = type;
              modalRef.componentInstance.where = this.mode == 'H' ? 'Action Item' : 'Checklist';
              modalRef.componentInstance.enableCheckboxSign = this.enableCheckboxSign;
              modalRef.result
                .then(result => {
                  this.utilityService.openModal();
                  if (result != null && result != 'signed') {
                    this.checklistService.submitChecklist(this.checklistInstanceID, pdfData, fileName).then((response: any) => {
                      this.fadeLabel(response.success);
                      this.checklistService
                        .sendChecklistSign(
                          result.data,
                          this.checklistInstanceID,
                          result.typeSign,
                          this.latitude != null ? this.latitude : null,
                          this.longitude != null ? this.longitude : null
                        )
                        .then((response: any) => {
                          this.fadeLabel(response.success);
                          if (response.success) {
                            this.sendChecklistsToVista(fileName);
                          } else {
                            this.utilityService.closeModal();
                          }
                        });
                    });
                  } else if (result == 'signed') {
                    this.checklistService.submitChecklist(this.checklistInstanceID, pdfData, fileName).then((response: any) => {
                      this.fadeLabel(response.success);
                      if (response.success) {
                        this.sendChecklistsToVista(fileName);
                      } else {
                        this.utilityService.closeModal();
                      }
                    });
                  }
                })
                .catch(() => {});
            });
          });
        } else {
          this.utilityService.closeModal();
        }
      }
    } else {
      let totalErrorCount = 0;
      this.formData.groupedItems.forEach((val: any) => {
        let itemErrorCount = 0;
        val.forEach((val2: any) => {
          val2.itemError = false;
          if (val2.IsRequired) {
            if (val2.ResponseTypeID == 5 || val2.ResponseTypeID == 11) {
              if (val2.img == null && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 16) {
              if ((val2.ItemResponse == null || val2.ItemResponse.length < 1 || isNaN(val2.ItemResponse)) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 3 || val2.ResponseTypeID == 12 || val2.ResponseTypeID == 26) {
              if ((val2.ItemComments == null || val2.ItemComments.length < 1) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
              let inputValid = false;
              if (val2.ValidationRegex != null && val2.ValidationRegex != '' && val2.ItemComments != null && val2.ItemComments != '') {
                inputValid = this.checkRegex(val2);
              } else {
                inputValid = true;
              }

              if (!inputValid) {
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 1 || val2.ResponseTypeID == 17) {
              if ((val2.ItemResponse == '1' || val2.ItemResponse == '3') && val2.ItemIsCorrected) {
                if (val2.CorrectedComments != null) {
                  if (val2.CorrectedComments.length < 1) {
                    val2.itemError = true;
                    itemErrorCount++;
                  }
                } else {
                  val2.itemError = true;
                  itemErrorCount++;
                }
              } else if (val2.ItemResponse == null && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else {
              if ((val2.ItemResponse == null || val2.ItemResponse.length < 1) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            }
            if (val2.IsRequiredAttachment && !val2.ItemHasAttachments) {
              val2.itemError = true;
              itemErrorCount++;
            }
          } else {
            if (val2.ResponseTypeID == 14)
              if (val2.ItemResponse === undefined) {
                val2.itemError = true;
                itemErrorCount++;
              }
          }
        });
        if (itemErrorCount > 0) {
          val.groupError = true;
          totalErrorCount++;
        } else {
          val.groupError = false;
        }
      });
      if (totalErrorCount != 0) this.missFieldAlert = true;
      else this.missFieldAlert = false;
    }
  }

  sendChecklistsToVista(fileName: string): void {
    if (this.mode == 'H' && this.templateInfo.AttachDocumentFlagValue != null && this.templateInfo.AttachDocumentFlagValue != 0) {
      this.checklistService
        .sendChecklistsToVista(
          this.checklistInstanceID,
          this.checklistDetails.ChecklistTemplateID,
          this.templateInfo.AttachDocumentFlagValue,
          this.checklistDetails.CreatedBy,
          this.templateInfo.AttachmentType,
          fileName
        )
        .then((response: any) => {
          this.fadeLabel(response.success);
          this.timeoutService.refreshTimeout();
          this.routeToMainPage();
        });
    } else {
      this.timeoutService.refreshTimeout();
      this.routeToMainPage();
    }
  }

  async saveRoute(): Promise<void> {
    this.alert = null;
    if (this.templateInfo.FillablePDFAttachmentID) {
      this.pdfViewer.restoreOriginalFieldStyles();
      const pdfData = await this.pdfViewer.getPDFData();
      const pdfFileName = this.generateFilename();
      this.employeeService.saveFileAttachment(134, this.checklistInstanceID, pdfData, pdfFileName, this.templateInfo.AttachmentType).then(
        () => {
          this.pdfFileIsDirty = false;
          this.route();
          return;
        },
        (errorResponse: any) => {
          this.alert = { type: 'danger', msg: 'Error when saving pdf:' + errorResponse?.error?.error };
          return;
        }
      );
    } else {
      this.route();
    }
  }

  route(): void {
    if (!this.checklistForm.form.dirty) {
      if (this.reqID == null && this.onboardID == null) this.navigateToMainPageURL();
      else if (this.onboardID != null && this.reqID == null) this.routeOnboard();
      else if (this.reqID != null) this.routeApplicant();
    }
  }

  saveRouteOnboarding(): void {
    if (!this.checklistForm.form.dirty) {
      this.navigate('/careers/tasks');
    }
  }

  routeToMainPage(): void {
    this.utilityService.closeModal();
    if (this.isOnboarding) this.routeOnboard();
    else if (this.isATS) this.routeApplicant();
    else this.navigateToMainPageURL();
  }

  routeApplicant(): void {
    if (!this.checklistForm.form.invalid) {
      this.checklistService.sendChecklistSign(null, this.checklistInstanceID, null, null, null).then((response: any) => {
        this.navigate('/hiring/applicantdetail/', this.reqID + '/' + this.onboardID + '/' + this.stageID + '/' + this.routing);
      });
    } else {
      this.navigate('/hiring/applicantdetail/', this.reqID + '/' + this.onboardID + '/' + this.stageID + '/' + this.routing);
    }
  }

  routeOnboard(): void {
    this.navigate('/hiring/onboardingdetails/', this.onboardID);
  }

  onboardSaveSign(): void {
    if (this.checklistForm.form.valid && this.errorCount == 0) {
      this.formData.groupedItems.forEach((val: any) => {
        val.forEach((val2: any) => {
          val2.itemError = false;
        });
        val.groupError = false;
      });
      this.checklistService.sendChecklistSign(null, this.checklistInstanceID, null, null, null).then((response: any) => {
        if (response.success) {
          this.navigate('/careers/tasks');
        }
      });
    } else {
      this.closeTab();
      let totalErrorCount = 0;
      this.formData.groupedItems.forEach((val: any) => {
        let itemErrorCount = 0;
        val.forEach((val2: any) => {
          val2.itemError = false;
          if (val2.IsRequired) {
            if (val2.ResponseTypeID == 5 || val2.ResponseTypeID == 11) {
              if (val2.img == null && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 16) {
              if ((val2.ItemResponse == null || val2.ItemResponse.length < 1 || isNaN(val2.ItemResponse)) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 3 || val2.ResponseTypeID == 12 || val2.ResponseTypeID == 26) {
              if ((val2.ItemComments == null || val2.ItemComments.length < 1) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
              let inputValid = false;
              if (val2.ValidationRegex != null && val2.ValidationRegex != '' && val2.ItemComments != null && val2.ItemComments != '') {
                inputValid = this.checkRegex(val2);
              } else {
                inputValid = true;
              }

              if (!inputValid) {
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 1 || val2.ResponseTypeID == 17) {
              if ((val2.ItemResponse == '1' || val2.ItemResponse == '3') && val2.ItemIsCorrected) {
                if (val2.CorrectedComments != null) {
                  if (val2.CorrectedComments.length < 1) {
                    val2.itemError = true;
                    itemErrorCount++;
                  }
                } else {
                  val2.itemError = true;
                  itemErrorCount++;
                }
              } else if (val2.ItemResponse == null && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else {
              if ((val2.ItemResponse == null || val2.ItemResponse.length < 1) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            }
            if (val2.IsRequiredAttachment && !val2.ItemHasAttachments) {
              val2.itemError = true;
              itemErrorCount++;
            }
          } else {
            if (val2.ResponseTypeID == 14)
              if (val2.ItemResponse === undefined) {
                val2.itemError = true;
                itemErrorCount++;
              }
          }
        });
        if (itemErrorCount > 0) {
          val.groupError = true;
          totalErrorCount++;
        } else {
          val.groupError = false;
        }
      });
      if (totalErrorCount != 0) this.missFieldAlert = true;
      else this.missFieldAlert = false;
    }
  }

  closeTab(): void {
    const accordion = document.getElementsByClassName('show');
    if (accordion.length > 0) {
      this.renderer.removeClass(accordion[0], 'show');
    }
  }

  async saveSign(type: any): Promise<void> {
    this.alert = null;
    if (this.templateInfo.FillablePDFAttachmentID) {
      await this.saveSignPdf(type);
    } else {
      this.saveSignNoPdf(type);
    }
  }

  async saveSignPdf(type: any): Promise<void> {
    const pdfValErrors = this.pdfViewer.validatePdfFields();
    if (pdfValErrors != null && pdfValErrors.length > 0) {
      this.alert = { type: 'danger', msg: 'The following fields have validation errors:' + pdfValErrors.join(', ') };
      return;
    }

    this.pdfViewer.restoreOriginalFieldStyles();
    const pdfData = await this.pdfViewer.getPDFData();
    const pdfFileName = this.generateFilename();
    this.employeeService.saveFileAttachment(134, this.checklistInstanceID, pdfData, pdfFileName, this.templateInfo.AttachmentType).then(
      () => {
        this.pdfFileIsDirty = false;
        const modalRef = this.modalService.open(SubmitChecklistSignModalComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.signed = this.checklistDetails.SignedOn;
        modalRef.componentInstance.type = type;
        modalRef.componentInstance.where = this.mode == 'H' ? 'Action Item' : 'Checklist';
        modalRef.componentInstance.enableCheckboxSign = this.enableCheckboxSign;
        modalRef.result
          .then(result => {
            this.checklistService
              .sendChecklistSign(
                result.data,
                this.checklistInstanceID,
                result.typeSign,
                this.latitude != null ? this.latitude : null,
                this.longitude != null ? this.longitude : null,
                pdfData,
                pdfFileName
              )
              .then((response: any) => {
                if (response != null) {
                  this.fadeLabel(response.success);
                  if (response.success) {
                    this.routeToMainPage();
                    return;
                  }
                }
              });
          })
          .catch(() => {});
      },
      (errorResponse: any) => {
        this.alert = { type: 'danger', msg: 'Error when saving pdf:' + errorResponse?.error?.error };
        return;
      }
    );
  }

  saveSignNoPdf(type: any): void {
    if (this.checklistForm.form.valid && this.errorCount == 0) {
      this.formData.groupedItems.forEach((val: any) => {
        val.forEach((val2: any) => {
          val2.itemError = false;
        });
        val.groupError = false;
      });
      this.updateOperations = 0;
      this.attemptedOperations = 0;
      this.successfulOpeartions = 0;
      this.updateQueue = [];
      let noAttachment = false;
      let invalidInput = false;
      this.missingAttachmentMsg = null;

      this.checklistItems.forEach((val: any) => {
        if (val.IsRequiredAttachment && !val.ItemHasAttachments) {
          noAttachment = true;
          return false;
        }
        if (val.ShowError) {
          invalidInput = true;
        }
      });
      if (noAttachment) {
        this.missingAttachmentMsg = 'Missing Attachment.';
      } else if (invalidInput) {
        this.missingAttachmentMsg = 'There are invalid fields in the form above. Please review the fields outlined in red.';
      } else {
        this.submitting = true;
        this.checklistItems.forEach(item => {
          if ((item.ResponseTypeID == 5 || item.ResponseTypeID == 11) && item.ItemResponseBinary == null) {
            if (item.IsRequired || item.img != null) {
              this.updateOperations++;
              this.updateQueue.push(item);
            }
          }
        });
        if (this.updateOperations > 0) {
          this.updateQueue.forEach((item: any) => {
            if (item.img != null && item.ItemResponseBinary != null) {
              if (item.ResponseTypeID == 5) this.signatureNEmpty[item.ChecklistInstanceItemID] = false;
              else if (item.ResponseTypeID == 11) this.signatureNEmpty2[item.ChecklistInstanceItemID] = false;
              this.updateItem(item, true, null);
            } else {
              if (item.ResponseTypeID == 5) this.signatureNEmpty[item.ChecklistInstanceItemID] = true;
              else if (item.ResponseTypeID == 11) this.signatureNEmpty2[item.ChecklistInstanceItemID] = true;
            }
          });
        } else {
          if (window.location.pathname.toLowerCase().indexOf('onboarding') > -1) {
            const initialState = {
              modalData: {
                modalTitle: 'Submit Checklist',
                modalMessage: 'Are you sure you want to submit your checklist?',
                modalAction: 'Submit',
                closeButtonText: 'Cancel',
                warningLevel: 'primary',
              },
              backdrop: 'static',
              size: 'md',
            };

            const modalRef = this.sharedModalService.show(WarningModalComponent, {
              initialState,
              ignoreBackdropClick: true,
              keyboard: true,
            });
            modalRef.onHide.subscribe(() => {
              const result = modalRef.content;
              if (result.userAction == 'Submit') {
                this.checklistService.sendChecklistSign(null, this.checklistInstanceID, null, null, null).then((response: any) => {
                  this.fadeLabel(response.success);
                  if (response.success) {
                    this.navigate('/careers/tasks');
                  }
                });
              }
            });
          } else {
            if (this.templateInfo.EnableWorkflow) {
              const modalRef = this.modalService.open(ViewChecklistWorkflowModalComponent, { size: 'md', backdrop: 'static' });
              modalRef.componentInstance.checklistInstanceID = this.checklistInstanceID;
              modalRef.componentInstance.checklistDetails = this.checklistDetails;
              modalRef.componentInstance.submitMode = true;
              modalRef.componentInstance.isSubmitted = this.isSubmitted;
              modalRef.componentInstance.latitude = this.latitude != null ? this.latitude : null;
              modalRef.componentInstance.longitude = this.longitude != null ? this.longitude : null;
              modalRef.componentInstance.canNotify = !(
                !this.checklistForm.form.valid ||
                this.signInitDirty ||
                this.signInitDirtyLoad ||
                this.errorCount > 0
              );
              modalRef.componentInstance.mode = this.mode;
              modalRef.result
                .then(result => {
                  if (result != null) {
                    this.checklistService
                      .sendChecklistSign(
                        result.data,
                        this.checklistInstanceID,
                        result.typeSign,
                        this.latitude != null ? this.latitude : null,
                        this.longitude != null ? this.longitude : null
                      )
                      .then((response: any) => {
                        this.fadeLabel(response.success);
                        if (response.success) {
                          this.routeToMainPage();
                        }
                      });
                  }
                })
                .catch(res => {});
            } else {
              const modalRef = this.modalService.open(SubmitChecklistSignModalComponent, { size: 'md', backdrop: 'static' });
              modalRef.componentInstance.signed = this.checklistDetails.SignedOn;
              modalRef.componentInstance.type = type;
              modalRef.componentInstance.where = this.mode == 'H' ? 'Action Item' : 'Checklist';
              modalRef.componentInstance.enableCheckboxSign = this.enableCheckboxSign;
              modalRef.result
                .then(result => {
                  this.checklistService
                    .sendChecklistSign(
                      result.data,
                      this.checklistInstanceID,
                      result.typeSign,
                      this.latitude != null ? this.latitude : null,
                      this.longitude != null ? this.longitude : null
                    )
                    .then((response: any) => {
                      if (response != null) {
                        this.fadeLabel(response.success);
                        if (response.success) {
                          this.routeToMainPage();
                        }
                      }
                    });
                })
                .catch(() => {});
            }
          }
        }
      }
    } else {
      let totalErrorCount = 0;
      this.formData.groupedItems.forEach((val: any) => {
        let itemErrorCount = 0;
        val.forEach((val2: any) => {
          val2.itemError = false;
          if (val2.IsRequired) {
            if (val2.ResponseTypeID == 5 || val2.ResponseTypeID == 11) {
              if (val2.img == null && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 16) {
              if ((val2.ItemResponse == null || val2.ItemResponse.length < 1 || isNaN(val2.ItemResponse)) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 3 || val2.ResponseTypeID == 12 || val2.ResponseTypeID == 26) {
              if ((val2.ItemComments == null || val2.ItemComments.length < 1) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
              let inputValid = false;
              if (val2.ValidationRegex != null && val2.ValidationRegex != '' && val2.ItemComments != null && val2.ItemComments != '') {
                inputValid = this.checkRegex(val2);
              } else {
                inputValid = true;
              }

              if (!inputValid) {
                itemErrorCount++;
              }
            } else if (val2.ResponseTypeID == 1 || val2.ResponseTypeID == 17) {
              if ((val2.ItemResponse == '1' || val2.ItemResponse == '3') && val2.ItemIsCorrected) {
                if (val2.CorrectedComments != null) {
                  if (val2.CorrectedComments.length < 1) {
                    val2.itemError = true;
                    itemErrorCount++;
                  }
                } else {
                  val2.itemError = true;
                  itemErrorCount++;
                }
              } else if (val2.ItemResponse == null && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            } else {
              if ((val2.ItemResponse == null || val2.ItemResponse.length < 1) && val2.IsRequired) {
                val2.itemError = true;
                itemErrorCount++;
              }
            }
            if (val2.IsRequiredAttachment && !val2.ItemHasAttachments) {
              val2.itemError = true;
              itemErrorCount++;
            }
          } else {
            if (val2.ResponseTypeID == 14)
              if (val2.ItemResponse === undefined) {
                val2.itemError = true;
                itemErrorCount++;
              }
          }
        });
        if (itemErrorCount > 0) {
          val.groupError = true;
          totalErrorCount++;
        } else {
          val.groupError = false;
        }
      });
      if (totalErrorCount != 0) this.missFieldAlert = true;
      else this.missFieldAlert = false;
    }
  }

  checkRegex(item): boolean {
    try {
      const flags = item.ValidationRegex.replace(/.*\/([gimy]*)$/, '$1');
      const pattern = item.ValidationRegex.replace(new RegExp('^/(.*?)/' + flags + '$'), '$1');
      const testRegex = new RegExp(pattern, flags);
      if (testRegex.test(item.ItemComments)) return true;
      else {
        this.alert = { type: 'danger', msg: 'There is a wrong setup on this field.' };
        return false;
      }
    } catch (error) {
      this.alert = { type: 'danger', msg: 'There is a wrong setup on this field.' };
      return false;
    }
  }

  closeAlert(): void {
    this.alert = null;
  }

  async pdfSpinner(): Promise<void> {
    this.utilityService.openModal();
    if (this.templateInfo.FillablePDFAttachmentID) {
      this.pdfViewer.restoreOriginalFieldStyles();
      const pdfData = await this.pdfViewer.getPDFData();
      const pdfFileName = this.generateFilename();
      this.employeeService
        .saveFileAttachment(134, this.checklistInstanceID, pdfData, pdfFileName, this.templateInfo.AttachmentType)
        .then(() => {
          this.pdfFileIsDirty = false;
          window.open('/Checklist/DownloadChecklists' + this.downloadQueryString, '_blank');
          this.pdfViewer.handleFormFieldStyling();
        });
    } else {
      window.open('/Checklist/DownloadChecklists' + this.downloadQueryString, '_blank');
    }
  }

  viewWorkflow(): void {
    const modalRef = this.modalService.open(ViewChecklistWorkflowModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.checklistInstanceID = this.checklistInstanceID;
    modalRef.componentInstance.checklistDetails = this.checklistDetails;
    modalRef.componentInstance.submitMode = false;
    modalRef.componentInstance.isSubmitted = this.isSubmitted;
    modalRef.componentInstance.latitude = this.latitude != null ? this.latitude : null;
    modalRef.componentInstance.longitude = this.longitude != null ? this.longitude : null;
    modalRef.componentInstance.canNotify = !(
      !this.checklistForm.form.valid ||
      this.signInitDirty ||
      this.signInitDirtyLoad ||
      this.errorCount > 0
    );
    modalRef.componentInstance.mode = this.mode;
    modalRef.result.then(() => {}).catch(() => {});
  }

  fadeLabel(status: any, text?: string): void {
    this.formData.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    this.saveText = text;
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }

  generateFilename(): string {
    let templateName = this.templateInfo?.ChecklistTemplateName;
    templateName = templateName ? templateName.replace(/[^a-zA-z\d]/g, ' ') + '_' : '';
    return templateName + this.checklistInstanceID + '.pdf';
  }

  navigate(location: string, fragment: string = null): void {
    if (this.pdfFileIsDirty) {
      this.alert = { type: 'danger', msg: 'You have unsaved changes. Please save before navigating.' };
      return;
    }
    this.router.navigate([location], { fragment: fragment });
  }

  private navigateToMainPageURL(): void {
    const fragment = this.mode == 'H' ? '/mode/' + this.mode : null;
    this.router.navigate(['/checklist/index'], { fragment: fragment });
  }
}
